class SideloadService {
  static sideloadByUrl = async (url) => {
    const response = await fetch(url, {
      method: "GET",
    });

    if (response.status !== 200) {
      return "";
    }

    return response.text();
  };
}

export default SideloadService;
